import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { PainSection } from '../components/sections/PainSection';
import { BlackHoleSection } from '../components/sections/BlackHoleSection';
import { AHASection } from '../components/sections/AHASection';
import { NEXUSSection } from '../components/sections/NEXUSSection';
const TestimonialsSection = lazy(() => import('../components/sections/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FinalCloseSection = lazy(() => import('../components/sections/FinalCloseSection').then(m => ({
  default: m.FinalCloseSection
})));
export function LandingPage() {
  return <div className="w-full min-h-screen bg-[#0f0f1e]" data-id="element-553">
      {/* Sticky top bar */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-[#0f0f1e]/90 backdrop-blur-md border-b border-[#3a3a5c]/30" data-id="element-554">
        <div className="max-w-6xl mx-auto px-5 py-3 flex items-center justify-between" data-id="element-555">
          <span className="font-display text-sm md:text-base font-bold text-gold-gradient tracking-wide" data-id="element-556">
            SRME™
          </span>
          <a href="#nexus" className="text-xs md:text-sm text-[#c9a84c] font-medium border border-[#c9a84c]/30 px-4 py-1.5 rounded-full
              hover:bg-[#c9a84c]/10 transition-colors duration-300
              focus:outline-none focus:ring-2 focus:ring-[#c9a84c]/50" data-id="element-557">
            Acceder ahora
          </a>
        </div>
      </div>

      <main data-id="element-558">
        <HeroSection data-id="element-559" />
        <PainSection data-id="element-560" />
        <BlackHoleSection data-id="element-561" />
        <AHASection data-id="element-562" />
        <NEXUSSection data-id="element-563" />
        <Suspense fallback={<div className="min-h-[200px]" data-id="element-565" />} data-id="element-564">
          <TestimonialsSection data-id="element-566" />
          <FinalCloseSection data-id="element-567" />
        </Suspense>
      </main>

      {/* Footer */}
      <footer className="w-full border-t border-[#3a3a5c]/30 bg-[#0f0f1e]" data-id="element-568">
        <div className="max-w-6xl mx-auto px-5 py-8 text-center" data-id="element-569">
          <p className="font-display text-sm font-bold text-gold-gradient mb-3" data-id="element-570">
            Sistema de Reprogramación Mental Espiritual™
          </p>
          <p className="text-[#6b6b7b] text-xs leading-relaxed max-w-lg mx-auto mb-4" data-id="element-571">
            Este producto es un recurso educativo digital. Los resultados pueden
            variar según el compromiso y la aplicación individual del protocolo.
            No sustituye asesoría médica o psicológica profesional.
          </p>
          <p className="text-[#6b6b7b] text-xs" data-id="element-572">
            © 2026 SRME™ · Todos los derechos reservados
          </p>
        </div>
      </footer>
    </div>;
}